module.exports = __webpack_public_path__ + "static/media/card4.460b7be7.jpg";